<div class="container-sm px-alt-3 main-container">
    <div class="search-component py-2">
        <div class="search-container">
            <input class="ihost-control" [(ngModel)]="search" name="search" type="search"
                placeholder="{{ 'dietaryTags.placeholders.search' | translate }}">
            <button (click)="clearSearch()" class="btn-clear" type="button">&times;</button>
        </div>
        <a class="btn btn-sm btn-main px-2 ms-2" (click)="showAddModal()">
            {{ 'common.buttons.addNew' | translate }}
        </a>
    </div>
</div>

<div class="container-sm mt-3 pb-5">
    <table class="list-table-item">
        <tbody *ngFor="let item of data | searchPipe:search:['name']">
            <tr>
                <td>{{item.name}}
                </td>
                <td class="td-actions w-1p text-nowrap">
                    <app-dotted-dropdown [context]="item" [actions]="actions"></app-dotted-dropdown>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<app-dietary-tag-modal #modal [selectedTag]="selectedTag" (onClose)="modalClosed($event)"></app-dietary-tag-modal>

<app-modal-dialog #deleteModal title=" {{ 'dietaryTags.delete' | translate }}" modalId="delete-dietary-tag-modal"
    okText="Delete" (onClose)="deleteModalClosed($event)">
    <p>{{ 'common.info.delete' | translate }}</p>
</app-modal-dialog>